<div class="jumbotron explanation-mobile-jumbotron">
	<div class="mobile-explanation-title" (click)="collapseMobile = !collapseMobile">
		<div class="explanation-img">
			<img src="/../../assets/img/{{themeService.theme}}/delegate.svg" alt="">
		</div>
		<div class="title">
			About <br> Delegates <br>
		</div>
		<i class="fa fas fa-chevron-down"></i>
	</div>
	<section class="mobile-explanations" [ngClass]="collapseMobile ? 'mobile-explanations-collapsed' : ''">
		<p>Share your plan with those closest to you in life.</p>
		<p>For each delegate, you can select which access permission to apply to each section of your plan. Each delegate’s permission can be updated by you at any time, meaning you’re in complete control over how you share your plan with others.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-contributor">
				<i class="fa fas fa-pen-alt contributor-fa"></i>
			<div class="contributor rights-div">Contributor</div>
			</div>
			
		</div>
		<p>Allow your delegate to view and edit all items stored in this section of your plan, so that they can help you to build and manage your plan.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-now">
				<i class="fa fas fa-eye viewer-now-fa"></i>
			<div class="viewer-now rights-div">Viewer - Now</div>
			</div>
			
		</div>
		<p>Allow your delegate to view all items stored in this section of your plan but prevent them from making any changes themselves.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-future">
				<i class="fa fas fa-eye viewer-future-fa"></i>
			<div class="viewer-future rights-div">Viewer - Future</div>
			</div>
			
		</div>
		<p>Allow your delegate to view all items stored in this section if you pass away or lose mental capacity.</p>
		<p>Should this happen, they must request access from us by providing either a death or medical certificate. <br> You can learn more about our plan unlock process <a class="go-to-request" [routerLink]="['/request-access']">here</a>.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-no-access">
				<i class="fa fas fa-lock no-access-fa"></i>
			<div class="no-access rights-div">No Access</div>
			</div>
			
		</div>
		<p>Prevent your delegate from accessing all items in this section of your plan, at all times.</p>
	</section>
</div>
